import { render } from "./upload-verify-note.vue?vue&type=template&id=89d90420&ts=true"
import script from "./upload-verify-note.ts?vue&type=script&lang=ts&external"
export * from "./upload-verify-note.ts?vue&type=script&lang=ts&external"

import "./upload-verify-note.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__